<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Business List</h2>
          </div>
          <!-- Members Listing-->
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-3 fresh-customer-filter"
            >
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Keywords"
                    aria-label="Search"
                    v-model="search_keywords"
                    v-on:keyup.enter="searchBusiness"
                    aria-describedby="search-transactions"
                  />
                  <div class="input-group-append" @click="searchBusiness()">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="fliter-main mr-auto mt-3 mt-md-0"></div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- All Remitters List -->
            <b-table
              responsive
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="
                typeof items === 'array' || typeof items === 'object'
                  ? items
                  : []
              "
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              striped
              show-empty
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(uuid)="data">
                <b-button
                  id="button1"
                  variant="outline-primary"
                  size="sm"
                  v-b-tooltip.hover
                  :data-original-title="data.value.businessid"
                  :title="data.value.businessid"
                  @click.prevent="copyTooltip($event)"
                >
                  <i class="fa fa-2x fa-barcode"></i>
                </b-button>
              </template>
              <template #cell(name)="row">
                <a class="font-color font-weight-bold">
                  <!-- cursor-pointer  @click="setBusiness(row)" -->
                  {{ row.value }}
                  <!-- <i class="fa fa-link text-theme"></i> -->
                </a>
              </template>
              <template #cell(status)="data">
                <p class="function-badge badge-group-table mb-0">
                  <span class="badge ml-0" :class="data.value.class">
                    {{ data.value.name }}
                  </span>
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  right
                  variant="outline-primary"
                >
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['business.status'])">
                    <b-dropdown-item
                      @click="updateStatus(data.item.uuid, 'approved')"
                    >
                      Approve
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="updateStatus(data.item.uuid, 'rejected')"
                    >
                      Reject
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="updateStatus(data.item.uuid, 'freezed')"
                    >
                      Freeze
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="updateStatus(data.item.uuid, 'suspended')"
                    >
                      Suspend
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="updateStatus(data.item.uuid, 'dormant')"
                    >
                      Dormant
                    </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['business.delete'])">
                    <b-dropdown-item @click="deleteItem(data.item.uuid)">
                      Delete
                    </b-dropdown-item>
                  </template>
                  <!-- <b-dropdown-item @click="showLinkBusiness(data)">Link Business</b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="d-flex py-3 align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
    <!-- <b-modal id="link_business" title="Link Business" hide-footer no-stacking no-close-on-backdrop>
            <ul class="list-unstyled mb-0 payment-single-transfer">
                <ValidationObserver v-slot="{ passes }">
                    <form @submit.prevent="passes(linkBusinessForm)" id="single-form">
                        <li class="mb-3">
                            <strong> Link with Business : <span>{{linkBusiness.selectedBusiness}}</span></strong>
                        </li>
                        <li class="mb-2">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Search by MerchantID" aria-label="Search by MerchantID" aria-describedby="search-business" v-model="linkBusiness.searchText" v-on:keyup.enter="setValue">
                                <div class="input-group-append" @click="setValue()">
                                    <span class="input-group-text" id="search-mail"><i class="icon-magnifier"></i></span>
                                </div>
                            </div>
                            <span class="text-danger error-msg" v-if="apiErrorCode=='E0147-104'|| apiErrorCode== 'E0147-105' || apiErrorCode=='V0147-001' || apiErrorCode=='0075-000'">{{apiErrorMsg}}</span>
                        </li>
                        <li class="mb-1">
                            <p> Business Name : <span>{{linkBusiness.setBusinessName}}</span></p>
                            <p> Country Name : <span>{{linkBusiness.setCountry}}</span></p>
                            <p> Category Name : <span>{{linkBusiness.setCategory}}</span></p>
                        </li>
                        <div class="align-items-center d-flex flex-column justify-content-between mt-3 w-100">
                            <b-button type="submit" variant="primary btn-mw" size="lg">Link Business</b-button>
                            <b-button @click="$bvModal.hide('link_business')" size="lg" variant="outline-secondary mt-3 btn-mw">Cancel</b-button>
                        </div>
                    </form>
                </ValidationObserver>
            </ul>
        </b-modal> -->
  </div>
</template>
<script>
import "@/plugins/sweetalert2";
const moment = require("moment");
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapGetters } from "vuex";
import {
  GET_BUSINESS_LIST,
  UPDATE_BUSINESS_STATUS,
  DELETE_BUSINESS,
} from "../../../store/actions.type.js";
import { ISLOADING } from "../../../store/mutations.type";
import { myFunction } from "@/common/common-helper.js";
import "vue-select/dist/vue-select.css";
export default {
  name: "BusinessComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
  },
  methods: {
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    deleteItem(data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to delete this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let params = {
              id: data.businessid,
              isdeleted: true,
            };
            this.$store.dispatch(DELETE_BUSINESS, params).then((response) => {
              if (response.data.code == "0102-000") {
                swalWithBootstrapButtons.fire(
                  "Deleted!",
                  "The business has been deleted.",
                  "success",
                );
                this.$store.commit(ISLOADING, true);
                this.getbusinesslist();
              }
            });
          }
        });
    },

    updateStatus(data, status) {
      let bstatus = "";
      if (status == "approved") {
        bstatus = "approve";
      } else if (status == "freezed") {
        bstatus = "freeze";
      } else if (status == "rejected") {
        bstatus = "reject";
      } else if (status == "suspended") {
        bstatus = "suspend";
      } else {
        bstatus = status;
      }
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "Do you want to " + bstatus + " business?", //"Do You want to change this busines status "+status+" !",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            let params = {
              id: data.businessid,
              status: status,
              isdeleted: false,
            };
            this.$store
              .dispatch(UPDATE_BUSINESS_STATUS, params)
              .then((response) => {
                if (response.data.code == "0102-000") {
                  swalWithBootstrapButtons.fire(
                    "Success!",
                    "Business status has been changed successfully.",
                    "success",
                  );
                  this.$store.commit(ISLOADING, true);
                  this.getbusinesslist();
                }
              });
          }
        });
    },

    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    //Recent transactions table Details copy
    copyTooltip: function (e) {
      var tooltipText = e.currentTarget.getAttribute("data-original-title");
      const inputCopyText = document.createElement("input");
      inputCopyText.value = tooltipText;
      document.body.appendChild(inputCopyText);
      inputCopyText.select();
      document.execCommand("copy");
      document.body.removeChild(inputCopyText);
    },

    async getbusinesslist() {
      let page = "";
      let size = "";
      let sortby = "";
      let sort = false;
      this.items = [];
      if (this.currentPage != undefined) {
        page = this.currentPage;
      } else {
        page = 1;
      }
      if (this.perPage != undefined) {
        size = this.perPage;
      } else {
        size = 20;
      }
      if (this.sortBy == "") {
        sortby = "createdat";
      } else {
        sortby = this.sortBy;
      }
      if (this.sortDesc == true) {
        sort = "DESC";
      } else {
        sort = "ASC";
      }
      this.currentPageJump = page;
      const tempitems = [];
      let tempparam = `?sorting=${sort}&sortby=${sortby}&pagesize=${size}&pagenumber=${page}`;
      if (this.search_keywords) {
        tempparam = tempparam + `&search=${this.search_keywords.trimStart()}`;
      }

      await this.$store
        .dispatch(GET_BUSINESS_LIST, tempparam)
        .then((response) => {
          if (response?.data?.code == "0075-000") {
            response.data.details.forEach((element) => {
              let statusObj = {};
              // element.isapproved==0?
              // (statusObj.name ='Inactive', statusObj.class= 'badge-danger')
              // :(statusObj.name ='Active', statusObj.class= 'badge-success')

              if (element.status == 0) {
                statusObj.name = "Pending";
                statusObj.class = "badge-danger";
              } else if (element.status == 1) {
                statusObj.name = "Approved";
                statusObj.class = "badge-success";
              } else if (element.status == 2) {
                statusObj.name = "Rejected";
                statusObj.class = "badge-warning";
              } else if (element.status == 3) {
                statusObj.name = "Freezed";
                statusObj.class = "badge-danger";
              } else if (element.status == 4) {
                statusObj.name = "Suspended";
                statusObj.class = "badge-danger";
              } else if (element.status == 5) {
                statusObj.name = "Dormant";
                statusObj.class = "badge-danger";
              } else {
                statusObj.name = "Pending";
                statusObj.class = "badge-danger";
              }

              let businessItem = {
                uuid: { businessid: element.businessid },
                name: element.name,
                countryname: element.countryname,
                dor:
                  element.createdat == null
                    ? "-"
                    : moment(element.createdat).format("YYYY-MM-DD"),
                ltd_to:
                  element.annualturnover == null ? "-" : element.annualturnover,
                account_type: element.categoryname,
                status: statusObj,
                action: "",
              };
              tempitems.push(businessItem);
            });
            this.totalRows = response.data.query.total;
            this.items = tempitems;
          } else {
            console.warn("⚠️ Unexpected response format:", response);
            this.items = [];
            this.totalRows = 0;
          }
        })
        .catch((error) => {
          console.error("❌ Failed to fetch business list:", error);
          this.$store.commit(ISLOADING, false);
          this.items = [];
          this.totalRows = 0;
          // Show error notification
          this.$toast.error("Failed to load business list. Please try again.", {
            position: "top-right",
          });
        });
    },
    searchBusiness() {
      this.$store.commit(ISLOADING, true);
      this.getbusinesslist();
    },

    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.sortBy != "") {
        this.$store.commit(ISLOADING, true);
        this.getbusinesslist();
      }
    },

    // showLinkBusiness(row){
    //     // console.log(row.item);
    //     this.apiErrorCode = "";
    //     this.apiErrorMsg = "";
    //     this.linkBusiness.selectedBusinessId = row.item.uuid;
    //     this.linkBusiness.selectedBusiness = row.item.name;
    //     this.linkBusiness.setBusinessId = '';
    //     this.linkBusiness.setBusinessName = '';
    //     this.linkBusiness.setCountry = '';
    //     this.linkBusiness.setCategory = '';
    //     this.linkBusiness.searchText = '';
    //     this.$bvModal.show('link_business');
    // },

    // async setValue(){
    //     this.apiErrorCode = "";
    //     this.apiErrorMsg = "";
    //     let paramData = {
    //         sorting : 'ASC',
    //         sortby : 'createdat',
    //         pagesize : 10,
    //         pagenumber : 1,
    //         search : this.linkBusiness.searchText,
    //         searchfield : 'merchandid'
    //     }
    //     const response = await this.$http.get(this.$baseurl+"business/list",{
    //         params: paramData,
    //         headers: {
    //             'Authorization': 'Bearer '+localStorage.getItem("jwtToken")
    //         },
    //     });
    //     // console.log(response);
    //     if(response.data.code == '0075-000'){
    //         if(response.data.query.total > 0){
    //             this.apiErrorMsg = '';
    //             this.apiErrorCode = '';
    //             response.data.details.forEach(element => {
    //                 this.linkBusiness.setSubBusinessId=element.businessid,
    //                 this.linkBusiness.setBusinessName=element.name,
    //                 this.linkBusiness.setCountry=element.countryname,
    //                 this.linkBusiness.setCategory=element.categoryname
    //                 // this.linkBusiness.setEmail='test@mailinator.com',
    //                 // this.linkBusiness.setPhone='123456789'
    //             })
    //         }else{
    //             this.apiErrorCode = response.data.code;
    //             this.apiErrorMsg = 'Provide valid merchant id';
    //             this.linkBusiness.setSubBusinessId='';
    //             this.linkBusiness.setBusinessName='';
    //             this.linkBusiness.setCountry='';
    //             this.linkBusiness.setCategory='';
    //         }
    //     }
    // },

    // linkBusinessForm(){
    //     let linkBusinessData = {
    //         businessid:this.linkBusiness.selectedBusinessId,
    //         subbusinessid:this.linkBusiness.setSubBusinessId
    //     }
    //     this.$http.post(this.$baseurl+"business/link/business", linkBusinessData,{
    //         headers: {
    //             'Authorization': 'Bearer '+localStorage.getItem("jwtToken")
    //         },
    //     }).then((res) => {
    //         // console.log(res);
    //         if(res.data.code == '0147-100') {
    //             shared.toastrSuccess(res.data.message);
    //             this.$bvModal.hide('link_business');
    //             this.refreshBusinessTable();
    //             this.apiErrorMsg = '';
    //             this.apiErrorCode = '';
    //         } else {
    //             this.apiErrorCode = res.data.code;
    //             this.apiErrorMsg = res.data.message;
    //         }
    //     }).catch((error) => {
    //         this.apiErrorCode = error.response.data.code;
    //         if(error.response.data.detail){
    //             this.apiErrorMsg = error.response.data.detail;
    //         }else {
    //             this.apiErrorMsg = error.response.data.message;
    //         }
    //     });
    // }
  },
  data() {
    return {
      breadCrumbIteams: [
        {
          title: "Business",
          links: "",
        },
        {
          title: "Business List",
          links: "",
        },
      ],
      items: [],
      fields: [
        {
          key: "uuid",
          label: "UUID",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "5%" },
        },
        {
          key: "name",
          label: "Business Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "countryname",
          label: "Country Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "dor",
          label: "Date of Registration",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "ltd_to",
          label: "LTD T/O",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "account_type",
          label: "Account Type",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "createdat",
      sortDesc: true,
      sortDirection: "asc",
      search_keywords: "",
    };
  },
  async mounted() {
    this.totalRows = this.items.length;
    this.$store.commit(ISLOADING, true);
    this.getbusinesslist();
  },
  computed: {
    ...mapGetters(["isLoading"]),
  },
};
</script>
